import { render, staticRenderFns } from "./ItemsCarousel.component.vue?vue&type=template&id=35637956&scoped=true"
import script from "./ItemsCarousel.component.vue?vue&type=script&lang=js"
export * from "./ItemsCarousel.component.vue?vue&type=script&lang=js"
import style0 from "./ItemsCarousel.component.vue?vue&type=style&index=0&id=35637956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35637956",
  null
  
)

export default component.exports